export default "__VITE_ASSET__d00ca1b8__"